import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import PropTypes, { any } from 'prop-types';
var CndzkEntranceApiUrl = /*#__PURE__*/function () {
  function CndzkEntranceApiUrl(options) {
    this.urlBase = void 0;
    this.apiConfig = void 0;
    this.iso = void 0;
    this.apis = {
      topLevelList: this.getApi.bind(this),
      topLevelInfo: this.getApi.bind(this),
      regionChain: this.getApi.bind(this),
      children: this.getApi.bind(this),
      regionChainByName: this.getApi.bind(this)
    };
    var urlBase = options.urlBase,
      apis = options.apis,
      iso = options.iso,
      apiConfig = options.apiConfig;
    urlBase = urlBase && urlBase.trim && urlBase.trim() || '';
    this.urlBase = urlBase;
    this.apis = apis;
    this.apiConfig = apiConfig;
    this.iso = iso;
    this.get = this.get.bind(this);
  }
  var _proto = CndzkEntranceApiUrl.prototype;
  _proto.get = function get(apiName, data) {
    if (data === void 0) {
      data = {};
    }
    var mSelf = this;
    var n = 20;
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        var action;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              action = function _action() {
                n--;
                var api = mSelf.getApi(apiName, data);
                if (n == 0 || api) {
                  var _mSelf$apiConfig;
                  axios({
                    url: mSelf.urlBase + "/" + api,
                    params: ((_mSelf$apiConfig = mSelf.apiConfig) === null || _mSelf$apiConfig === void 0 ? void 0 : _mSelf$apiConfig.params) || {}
                  }).then(function (res) {
                    resolve(((res || {}).data || {}).data || []);
                  })["catch"](function (err) {
                    console.error('CnAddressM Error: api request failed', err);
                    reject();
                  });
                } else if (n) {
                  setTimeout(action, 300);
                } else {
                  console.error('CnAddressM Error: error');
                }
              };
              action();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
  _proto.getApi = function getApi(apiName, data) {
    if (data === void 0) {
      data = {};
    }
    var iso = this.iso;
    var _data = data,
      id = _data.id,
      divisionId = _data.divisionId,
      divisionToken = _data.divisionToken;
    var arr = [this.apiConfig[apiName]];
    if (apiName === 'topLevelList') {
      return arr.join('/');
    } else if (apiName == 'topLevelInfo') {
      arr.push(iso);
      return arr.join('/');
    } else if (apiName === 'regionChain' || apiName === 'children') {
      arr.push(id || divisionId);
      return arr.join('/');
    } else if (apiName === 'regionChainByName') {
      arr.push(divisionToken);
      return arr.join('/');
    } else {
      return false;
    }
  };
  return CndzkEntranceApiUrl;
}();
CndzkEntranceApiUrl.propTypes = {
  urlBase: PropTypes.string,
  iso: PropTypes.string,
  apis: any,
  apiConfig: any
};
export default CndzkEntranceApiUrl;